import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, ProjectExpenseType } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projectExpenseTypes: Identifiable<ProjectExpenseType>[];
  retrieveProjectExpenseTypes(
    request: Boundaries["retrieveProjectExpenseTypes"]["request"],
  ): void;
}

function useRetrieveProjectExpenseTypes(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveProjectExpenseTypesRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveProjectExpenseTypesRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveProjectExpenseTypesRequestFailure,
    ),
    projectExpenseTypes: useSelector(selector.getProjectExpenseTypes),
    retrieveProjectExpenseTypes: core.retrieveProjectExpenseTypes,
  };
}

export { useRetrieveProjectExpenseTypes };
